import { ChangeEvent, FunctionComponent, useEffect, useState } from 'react';
import classnames from 'classnames';

import SearchIcon from 'theme/icons/search.svg';

import Button, { ButtonIconPositions, ButtonIconTypes, ButtonStyles } from 'components/layout/Button';
import Input from 'components/layout/forms/Input';
import { ValuesTypes as PrevStateTypes } from 'components/modules/public/pages/CompanySites/types';
import { ISearchParam, SearchParamCity, SearchParamPage, SearchParamTime, SearchParamValue, SearchParamValues, useSearchParams } from 'hooks/useSearchParams';

import ExpandableMenuBlock from './blocks/ExpandableMenu';
import StyledComponent from './styles';
import { Props } from './types';


const PublicPageHomeSectionHero: FunctionComponent<Props> = ({
    translations: { heroImage, header, search },
    jobCategories,
    searchParams: globalSearchParams,
    onSearch,
}) => {
    const [filterExpandable, setFileterExpandable]: [boolean, Function] = useState(false);

    const { getSearchParams, getSearchParamsQueryValues, getSearchParamValue, setSearchParamValue } = useSearchParams({

        category: new SearchParamValues('jobCategorySlugs'),
        search: new SearchParamValue('search'),
    });

    useEffect(() => {
        setSearchParamValue('category', globalSearchParams.category.getValue() );
        setSearchParamValue('search', globalSearchParams.search.getValue() );
    }, [globalSearchParams]);

    const searchParams = getSearchParams();

    const handleSearch = () => {
        onSearch( searchParams );
    };


    return (
        <StyledComponent className="public-page-company-sites-section-hero">
            <div className="hero-wrapper">
                <img
                    className='hero-image'
                    src={heroImage}
                    alt=""
                    width="1920"
                    height="366"
                />
                <header className="hero-header">
                    <h1 className="header-title">{header}</h1>
                </header>
            </div>
            <div className="search-wrapper">
                <div className="search-box">
                    <h2 className="search-title">{search?.searchTitle}</h2>
                    <div className="search-fields">
                        <Input
                            name="search"
                            label={search?.inputs?.search?.label}
                            placeholder={search?.inputs?.search?.placeholder}

                            onChange={(event: ChangeEvent<HTMLInputElement>) => setSearchParamValue('search', event.target.value)}
                            value={searchParams.search.getValue()}
                        />
                        <Button
                            className={classnames('industry-button', {
                                'cliked': Boolean(filterExpandable),
                            })}
                            style={ButtonStyles.None}
                            onClick={() => setFileterExpandable((prevState:boolean) => !prevState)}
                            icon={{
                                type:ButtonIconTypes.Element,
                                position: ButtonIconPositions.After,
                                value: filterExpandable ? (
                                    <img
                                        src='/images/icons/minus-black.svg'
                                        width="20"
                                        height="20"
                                    />
                                ) : (
                                    <img
                                        src='/images/icons/plus-black.svg'
                                        width="20"
                                        height="20"
                                    />
                                ),
                                alt: '',
                            }}
                        >
                            {search?.inputs?.industry?.replace('{count}', searchParams.category.getValue().length?.toString() || '0')}
                        </Button>
                        <Button
                            className="submit-button"
                            onClick={() => {
                                handleSearch();
                                setFileterExpandable(false);
                            }}
                            icon={{
                                type:ButtonIconTypes.Element,
                                position: ButtonIconPositions.Before,
                                value: (<img src={SearchIcon} />),
                                alt: '',
                            }}
                        >
                            {search?.inputs?.submit}
                        </Button>
                    </div>
                </div>
                {filterExpandable && (
                    <ExpandableMenuBlock
                        list={jobCategories}
                        values={searchParams}
                        onChange={setSearchParamValue}
                        onSearch={handleSearch}
                        onClose={setFileterExpandable}
                        buttonProps={search?.expandableMenuBlock?.buttonProps}
                    />
                )}
            </div>
        </StyledComponent>
    );
};

export default PublicPageHomeSectionHero;
